import React, { useState, useMemo } from 'react';
import { Button } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { useNavigate } from 'react-router-dom';
import { useSnackbar } from 'notistack';
import { useDeleteLocationMutation } from '../../../api/locations';

export const LocationsMenu = ({ Component, row, handleAction }) => {
    const [actionType, setActionType] = useState();
    const navigate = useNavigate();
    const { enqueueSnackbar } = useSnackbar();
    const [deleteLocation] = useDeleteLocationMutation();

    const handleDelete = async () => {
        setActionType();
        const bodyFormData = new FormData();
        bodyFormData.append('id', row.id);
        try {
            const response = await deleteLocation(bodyFormData).unwrap();
            if (!response) return;
            if (response?.status === 'ERROR') throw new Error(response?.message);
            enqueueSnackbar('Location deleted successfully', { variant: 'success' });
            handleAction();
        } catch (err) {
            if (err?.statusCode === 400) enqueueSnackbar(err?.data?.message, { variant: 'error' });
            else enqueueSnackbar(err?.message || 'Something went wrong!', { variant: 'error' });
        }
    };

    const dialogContent = useMemo(() => {
        if (actionType === 'delete')
            return {
                title: 'Delete Location',
                confirmation: `Are you sure you want to delete this Location?`,
                actions: (
                    <React.Fragment>
                        <Button size="large" onClick={() => setActionType()}>
                            Cancel
                        </Button>
                        <Button size="large" variant="contained" onClick={handleDelete}>
                            Delete
                        </Button>
                    </React.Fragment>
                ),
            };
    }, [actionType]);

    const actionItems = [
        {
            label: 'Modify',
            type: 'modify_location',
            icon: <EditIcon />,
            onClick: () => navigate(`/settings/locations/edit/${row.id}`),
            permissions: ['ROLE_BASE_PERMISSION_INDEX_DELETE_LOCATION'],
        },
        {
            label: 'Delete',
            type: 'delete',
            icon: <DeleteIcon />,
            onClick: (action) => setActionType(action.type),
            permissions: ['ROLE_BASE_PERMISSION_INDEX_DELETE_LOCATION'],
        },
    ];

    return <Component actions={actionItems} dialog={dialogContent} onDialogClose={() => setActionType()} />;
};
